const LOADER_TYPES = {
  wingkey: 'wingkey',
  timeturner: 'timeturner',
  paintbrush: 'paintbrush',
};

export default LOADER_TYPES;
